<div class="form-review-sessions">
    <h3>Your Sessions</h3>
    <% for( var i = 0; i < preview.length; i++) { %>
        <div class="form-review-sessions-item">
            <p class="form-review-sessions-item-title"><%= preview[i].name %></p>
            <p><%= preview[i].time %></p>
            <p><%= preview[i].track %></p>
        </div>
    <% } %>
</div>